import config from 'config/config';

import { getPanelListFromBusinessChoice } from 'pages/PagePanel/hooks/usePanelList';
import { AnswersState } from 'schemas/answerStateSchema';
import { getApiItems } from 'store/hooks/useApiItems';

import { getPanelOptions } from './getPanelOptions';
import { notifySentry } from './error/notifySentry';
import { getInverterItem } from './getInverterItem';

/**
 * Retrieve the offer items based on the answers
 * @param answers: we need the answers to get the correct items
 * @param numPanels: we need the number of panels to get the correct inverter based on power
 * @returns
 */
export const getOfferItems = (answers: AnswersState, numPanels: number) => {
  const items = getApiItems();
  const { panelId, needBattery, needVehicle, roofType } = answers;

  // panel
  const panelOptions = getPanelOptions(
    panelId!,
    getPanelListFromBusinessChoice(answers.businessChoice)
  );
  const panelItem = items.solarPanels.find(
    (x) => x.id === panelOptions?.apiId
  )!;

  // inverter
  const { inverterItem, quantity: numInverters } = getInverterItem(
    answers,
    items,
    numPanels
  );

  // battery
  const batteryItem = needBattery
    ? items.batteries.find((x) => x.inverterType === inverterItem.inverterType)
    : undefined;

  if (needBattery && !batteryItem) {
    notifySentry(new Error('No battery found for the current inverter type'), {
      answers,
      items,
    });
  }

  // charger
  const chargerItem = needVehicle ? items.carCharger : undefined;

  // installation
  const roofTypeId = config.options.roofTypes.find(
    (x) => x.id === roofType
  )?.type;

  // installation type
  const installationItem = items.installationTypes.find(
    (x) => x.roofType === roofTypeId
  );

  // sanity check
  // we need panel items, inverter item and installation items.
  // TODO: handle this another way, to be sure to have a proper message for client / debug
  const result = {
    panelItem,
    numInverters,
    inverterItem,
    batteryItem,
    chargerItem,
    installationItem,
  };
  if (!panelItem) {
    console.error('panel item not found', result);
    throw new Error('panel item not found');
  }
  if (!inverterItem) {
    console.error('inverter item not found', result);
    throw new Error('inverter item not found');
  }
  if (!installationItem) {
    console.error('installation item not found', result);
    throw new Error('installation item not found');
  }

  // Return all items
  return result;
};
